<template>
    <div>
        <input type="number" placeholder="输入签约支付金额" v-model="signPriceVal" @blur="getPriceVal" class="signPrices"/><span>&nbsp;元</span>   
    </div>
</template>
<script>
export default {
    props:['signatoryId','curIndex','amount'],
    data(){
        return {
            signPriceVal:""
        }
    },
    methods:{
        getPriceVal(){
            if(this.signPriceVal!=''){
                if(this.signPriceVal.indexOf('.')!=-1){
                    this.$bus.$emit("setPrcieVal",{id:this.signatoryId,amount:(this.signPriceVal-0).toFixed(2),ind:this.curIndex})
                }else{
                    this.$bus.$emit("setPrcieVal",{id:this.signatoryId,amount:this.signPriceVal,ind:this.curIndex})
                }
            }else{
                this.$bus.$emit("setPrcieVal",{id:this.signatoryId,amount:'',ind:this.curIndex})
            }
        }
    },
    mounted(){
        this.signPriceVal=this.amount+'';
        this.getPriceVal();
    },
    watch:{
        'amount'(data){
            this.signPriceVal=this.amount+'';
            this.getPriceVal();
        }
    }
}
</script>
<style scoped lang="scss">
.signPrices{
   border: 1px solid #E4E8EB;
   border-radius: 2px;
   width: 108px;
   height: 28px;
}
.signPrices::-webkit-outer-spin-button,
.signPrices::-webkit-inner-spin-button{
    -webkit-appearance: none !important;
    margin: 0; 
}
</style>